import { isCorn } from './isCorn.js';
/**
 * @example
 * // returns { serviceName: 'claims-v2', resourceType: 'claim', resourceId: '223SSU6SKL' }
 * getCornKernels('corn:claims:claim:223SSU6SKL')
 * @param corn corn to deconstruct
 * @returns Corn kernels
 */
export function getCornKernels(corn) {
    const isValid = isCorn(corn);
    if (!isValid) {
        throw new Error('Invalid Corn');
    }
    const [_, serviceName, resourceType] = corn.split(':');
    const resourceId = _ &&
        serviceName &&
        resourceType &&
        corn.substring(`corn:${serviceName}:${resourceType}:`.length);
    return {
        corn: 'corn',
        serviceName: serviceName,
        resourceType: resourceType,
        resourceId: resourceId,
    };
}
